export default {"src":"/_next/static/media/microchip.273689cf.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};